module.exports = __webpack_public_path__ + "static/hill_giant-ee6bb9f6a0fbe0fbf74c461d2ff91b2e.png";